// extracted by mini-css-extract-plugin
export default {"tab":"O__AAtCi","selected":"wDFXWVjR"};